import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { UserSignupDataMobileService } from "./user-signup-data-mobile.service";
import { UserSignupMockService } from "./user-signup-data-mock.service";
import { UserSignupDataService } from "./user-signup-data.service";
import { DomainOrigin } from "./model/domain-origin";
import { UserUpdateDataMobileService } from "./user-update-data-mobile.service";

@Injectable({
  providedIn: "root",
})
export abstract class UserSignupFactoryService {
  private services = new Map<DomainOrigin, UserSignupDataService>();

  constructor(private handlerService: HandlerService) {}

  public getService(origin: DomainOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DomainOrigin): UserSignupDataService {
    switch (origin) {
      case DomainOrigin.Registration:
        const serviceUserMobile = new UserSignupDataMobileService(
          this.handlerService
        );
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DomainOrigin.UpdateRegistration:
        const serviceUserUpdateMobile = new UserUpdateDataMobileService(
          this.handlerService
        );
        this.services.set(origin, serviceUserUpdateMobile);
        return serviceUserUpdateMobile;
      case DomainOrigin.Mock:
        const serviceMock = new UserSignupMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new UserSignupMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }
}
